import { useMemo } from 'react';
import {
  DepartmentHierarchyNodeFragmentFragment as DepartmentHierarchyNode,
  useDepartmentHierarchyQuery,
} from 'graphql-common';

interface AncestorNode extends DepartmentHierarchyNode {
  parent?: AncestorNode | null;
}

// Root-first ancestor chain for `departmentId`, ending with the department
// itself. Shared by the view page's hierarchy tree and the form's resulting
// hierarchy preview, both of which walk the same `departmentHierarchy` query
// shape (BE contract: up to 4 nested `parent` levels).
export default function useDepartmentAncestorChain(departmentId?: string) {
  const ancestorsQuery = useDepartmentHierarchyQuery({
    variables: { id: departmentId as string },
    skip: !departmentId,
    fetchPolicy: 'cache-and-network',
  });

  const ancestorChain = useMemo<DepartmentHierarchyNode[]>(() => {
    const chain: DepartmentHierarchyNode[] = [];
    let node = ancestorsQuery.data?.data as AncestorNode | undefined;
    while (node) {
      chain.unshift(node);
      node = node.parent || undefined;
    }
    return chain;
  }, [ancestorsQuery.data]);

  return {
    ancestorChain,
    loading: ancestorsQuery.loading,
  };
}
